import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { BaseResponse } from '../models/response/BaseResponse';
import { QrChallenge } from '../models/QrChallenge';

@Injectable({
  providedIn: 'root'
})
export class QrChallengeService extends HttpService {

  create(projectId: string, deviceToken: string, password?: string): Observable<BaseResponse<QrChallenge>> {
    const payload: {project_id: string; device_token: string; password?: string} = {
      project_id: projectId,
      device_token: deviceToken,
    };

    if (password) {
      payload.password = password;
    }

    return this.post('qr-challenges', payload);
  }
}
